import { PapiDaSharedDeviationSubmitGroupDestinations } from '@wix/da-papi-types';
import { DropdownOption } from '@wix/da-ds/pkg/Dropdown/types';
import { SubmitAdapter } from '../../types';
import { GroupSelectValue } from './types';

export const initAdapter = (
  inGroups: PapiDaSharedDeviationSubmitGroupDestinations['inGroups'] = [],
  groupDestinations: PapiDaSharedDeviationSubmitGroupDestinations['groupDestinations'] = []
) => {
  return Object.values(
    groupDestinations.reduce((accumulator, { group, folder }) => {
      const folderOption: DropdownOption = {
        label: folder.name,
        value: `${folder.folderId}`,
        selected: !!inGroups.find(
          item => item.group.userId === group.userId && item.folder.folderId === folder.folderId
        ),
      };
      if (accumulator[group.userId]) {
        accumulator[group.userId].items.push(folderOption);
      } else {
        accumulator[group.userId] = {
          group,
          groupId: `${group.userId}`,
          groupLabel: group.username,
          selected: inGroups.some(item => item.group.userId === group.userId),
          items: [folderOption],
        };
      }
      return accumulator;
    }, {})
  ) as GroupSelectValue;
};

export const submitAdapter: SubmitAdapter = ({ groups }) => {
  const selectedGroups = (groups || []).filter(item => item.selected);
  const selectedFolderIds = selectedGroups.map(group => {
    const folderId = parseInt(group.items.find(item => item.selected)?.value ?? '', 10);
    return isNaN(folderId) ? 0 : folderId;
  });

  return {
    groups: selectedGroups.map(({ group }) => group.userId),
    group_folders: selectedFolderIds,
  };
};
